/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {FlagOutlined, LinkOutlined, MessageOutlined, TitleOutlined} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {ESTADOANUNCIOS} from "../../Constantes";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";


const Formulario_Pagos = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >




                <Grid container size={12}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Nombre del cliente'}
                                  dato={'nombre'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={3} nombre={'Descripcion del cobro (servicio que se dará)'}
                                  dato={'descripcion'} {...props}

                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero  nombre={'Valor'}
                                  dato={'valor'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Pagos